define('base/layout',['require','exports','module','base/view','base/region','underscore'],function(require, exports, module) {
  "use strict";

  var View = require("base/view"),
      Region = require("base/region"),
      _ = require("underscore");

  var Layout = View.extend({
    constructor: function(options) {
      options = options || {};
      var regions = options.regions || this.regions || {};
      this.regions = {};
      this._regions = [];
      _.each(regions, this.addRegion, this);
      Layout.__super__.constructor.apply(this, arguments);
    },
    regionType: Region,
    addRegions: function(regions) {
      _.each(regions, this.addRegion, this);
    },
    addRegion: function(value, name) {
      var RegionType = value.regionType || this.regionType,
          selector = (typeof(value) === "string")? value : value.selector,
          region = new RegionType({$el: this.el? this.$(selector) : null});
      this._regions.push({region: region, selector: selector});
      this.regions[name] = region;
      // the $ shortcut is a new idea. Remove this comment if
      // read after a while and never had problems with it;
      this["$" + name] = this.regions[name] = region;
    },
    detachRegions: function() {
      _.each(this._regions, function(regionData) {
        regionData.region.$el.detach();
      });
    },
    reattachRegions: function() {
      /* NOTE:
         I do this in two steps:
         1) Select all the $el from the template for the regions.
         2) Attach the regions to the $el's
         It's like this to AVOID COLLISION with NESTED LAYOUTS
         if the regions get attached in the same loop that looks for the
         $el's, the selector could be matched in the CONTENTs of previously
         attached regions.
      */
      _.chain(this._regions)
        .map(function(regionData) {
          return {regionData: regionData, $el: this.$(regionData.selector)};
        }, this)
        .each(function(data) {
          data.regionData.region.setElement(data.$el);
        });
    },
    render: function() {
      this.detachRegions();
      Layout.__super__.render.apply(this, arguments);
      this.reattachRegions();
      this.trigger("render");
      return this;
    },
    setElement: function() {
      Layout.__super__.setElement.apply(this, arguments);
      this.reattachRegions();
    },
    delegateEvents: function() {
      Layout.__super__.delegateEvents.apply(this, arguments);
      _.each(this._regions, function(regionData) {
        regionData.region.delegateEvents();
      });
    },
    remove: function() {
      module.exports.__super__.remove.call(this);
      if (this.regions) {
        _.invoke(this.regions, "close");
      }
    }
  });

  module.exports = Layout;

});

